import { createFileRoute } from "@tanstack/react-router";

import { PraxaConnectorCatalog } from "../components/praxa/PraxaConnectorSurface";

export const Route = createFileRoute("/w/$workspaceId/connectors/")({
  component: PraxaConnectorsRoute,
});

function PraxaConnectorsRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaConnectorCatalog workspaceId={workspaceId} />;
}
